import { create } from "zustand"
import { createJSONStorage,persist } from "zustand/middleware"

import type { User } from "@/modules/types"

interface AuthState {
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  isNewUser: boolean | null
  isIgnoreReferral: boolean | null
  // Actions
  setIsNewUser: (isNewUser: boolean) => void
  setIsIgnoreReferral: (isIgnoreReferral: boolean) => void
  login: (payload: { accessToken: string; refreshToken: string; isNewUser?: boolean }) => void
  logout: () => void
  setUser: (user: User) => void
  resetAll: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isNewUser: null,
      isIgnoreReferral: false,

      setIsNewUser: (isNewUser) => set({ isNewUser }),

      setIsIgnoreReferral: (isIgnoreReferral) => set({ isIgnoreReferral }),

      login: ({ accessToken, refreshToken, isNewUser }) => {
        set({ accessToken, refreshToken, isNewUser })
      },

      setUser: (user) => set({ user }),

      logout: () => {
        set({
          user: null,
          accessToken: null,
          refreshToken: null
        })
      },

      resetAll: () => {
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isNewUser: null,
          isIgnoreReferral: false
        })
      }
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => window.localStorage)
    }
  )
)
